/**
 * Configuration centralisée pour l'application
 * Permet de basculer facilement entre mode développement (mocks) et production (API réelle)
 */

export const config = {
  // API Configuration
  // Développement: API Gateway local sur port 8000 avec préfixe /land
  // Production: API Gateway sur https://api.wanzzo.com/land/api/v1
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:8000/land/api/v1',
  
  // Environment
  isDevelopment: import.meta.env.MODE === 'development',
  isProduction: import.meta.env.MODE === 'production',
  
  // Mocks Configuration
  useMocks: import.meta.env.VITE_USE_MOCKS === 'true' || import.meta.env.MODE === 'development',
  
  // Auth0 Configuration
  auth0: {
    domain: import.meta.env.VITE_AUTH0_DOMAIN || 'your-tenant.auth0.com',
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || 'your-client-id',
    audience: import.meta.env.VITE_AUTH0_AUDIENCE || 'https://api.wanzo.com',
  },
  
  // Third-party Services
  googleMaps: {
    apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
  },
  
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL || '',
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  },
  
  // Feature Flags
  features: {
    enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    enableErrorReporting: import.meta.env.VITE_ENABLE_ERROR_REPORTING === 'true',
    enableExperimentalFeatures: import.meta.env.VITE_ENABLE_EXPERIMENTAL === 'true',
  },
  
  // API Timeouts and Limits
  api: {
    timeout: 10000, // 10 seconds
    retryAttempts: 3,
    retryDelay: 1000, // 1 second
  },
  
  // Upload Limits
  upload: {
    maxFileSize: 5 * 1024 * 1024, // 5MB
    allowedImageTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
    allowedDocumentTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  },
  
  // Pagination Defaults
  pagination: {
    defaultLimit: 10,
    maxLimit: 100,
  },
} as const;

/**
 * Helper function to check if we should use mocks
 */
export const shouldUseMocks = (): boolean => {
  return config.useMocks;
};

/**
 * Helper function to get the appropriate service based on environment
 * @param mockService - The mock service to use in development
 * @param apiService - The real API service to use in production
 * @returns The appropriate service based on configuration
 */
export const getService = <T>(mockService: T, apiService: T): T => {
  return shouldUseMocks() ? mockService : apiService;
};

export default config;
